<div class="base-modal black" [class]="animation ? 'animate ' + animation : ''">
    <div class="base-modal-content">
        <div class="base-modal-content-inner" [class]="verticalAlign">
            <ng-content></ng-content>
        </div>
    </div>
</div>